import { mutatorAction } from 'satcheljs';
export var updateIsLoadingFullBody = mutatorAction('updateIsLoadingFullBody', function (viewState, isLoading) {
    viewState.isLoadingFullBody = isLoading;
});
export var updateCachedItemBodies = mutatorAction('updateCachedItemBodies', function (cachedItem, responseItem) {
    if (responseItem.UniqueBody) {
        cachedItem.UniqueBody = responseItem.UniqueBody;
    }
    if (responseItem.NormalizedBody) {
        cachedItem.NormalizedBody = responseItem.NormalizedBody;
    }
});
//# sourceMappingURL=loadFullBodyMutators.js.map